import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants'


/*

Props:


*/

const StyledDiv = styled.div`
  font-size: 25px;
  font-family: "Open Sans";
  font-weight: 300;
  color: rgb(123, 123, 123);
  margin-bottom: 10px;
`;

const SpanSubTitle = ({ styles, children, ...rest }) => (
  <StyledDiv style = {styles} {...rest}>
      { children }
  </StyledDiv>
)

export default SpanSubTitle



// WEBPACK FOOTER //
// ./src/js/components/TextModifiers/SpanSubTitle.jsx